export default __webpack_public_path__ + "media/logo.339fccd6.ico";